<template>
  <v-menu 
    v-model="menuOptions.showMenu"
    offset-y
    :position-x="menuOptions.x"
    :position-y="menuOptions.y"
    min-width="20.5%"
    absolute
    bottom
  >
    <v-list>
      <v-list-item v-for="(item, index) in menuItems" :key="index" @click="actionClickOnItem(item)">
        <v-list-item-title>{{ evaluateExpression(item.title) }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
  import inputMixin from '../../mixins/input-mixin'
  import baseMixin from '../../mixins/base-mixin'
  import actionMixin from '../../mixins/actions-mixin'
  import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'

  export default {
    props: ['menuItems', 'menuOptions'],
    mixins: [baseMixin, inputMixin, actionMixin, widgetsWrapperMixin],
    methods: {
      actionClickOnItem(item) {
        this.invokeActionOnClick(this.model.OnClickAction, item)
      }
    }
  }
</script>
